import $api from "@/frontend/shared/api/axios";

export async function createPortfolioCompanies({ ids, stageId }: { ids: number[]; stageId: number }) {
  const response = await $api.post("/portfolio-companies", {
    stageId,
    companies: ids.map((id) => ({ companyId: id }))
  });
  return response.data.data;
}
